// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class ToggleClass extends WebComponent {
    constructor(props) {
        super(props);
        this.toggleClass = this.toggleClass.bind(this);
    }

    didMount() {
        const self = this;

        this.element.addEventListener('click', function(e) {
            e.stopPropagation();
            self.toggleClass();
        })
        this.element.addEventListener('keydown', function(e) {
            if ((e.which || e.keyCode) === 13) {
                self.toggleClass();
            }
        })
    }

    toggleClass() {
        const {
            actionClass,
            actionTarget,
            separator = ';',
        } = this.props;

        if (actionTarget) {
            const targetSet = actionTarget.split(separator);
            targetSet.forEach(element => document.querySelector(element).classList.toggle(actionClass));
        }
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ToggleClass.js